module.exports = "<svg id=\"e4b8f0b6-1341-4630-994c-15530e166077\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>down-arrow</title><path d=\"M44.49,18,27.84,31.34v-.1L25,33.56l-2.83-2.29v.06L5.52,18a3,3,0,0,0-4,.44,2.85,2.85,0,0,0,.44,4l21.26,17a2.59,2.59,0,0,0,1.77.62h0a4.18,4.18,0,0,0,1.77-.62L48,22.44a2.85,2.85,0,0,0,.44-4A3,3,0,0,0,44.49,18Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/down-arrow.svg
// module id = 88lS
// module chunks = 11